"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _NotificationActions = require("../actions/NotificationActions");

var _AlertConstants = require("UIComponents/alert/AlertConstants");

var defaultId = 0;
var timeouts = {};

var _default = function _default(store) {
  return function (next) {
    return function (action) {
      var dispatch = store.dispatch;
      var result = next(action);

      if (!action.meta) {
        return result;
      }

      if (action.meta.removeNotification && action.meta.removeNotification.id) {
        dispatch((0, _NotificationActions.removeNotification)(action.meta.removeNotification.id));
      }

      if (!action.meta.notification) {
        return result;
      }

      var _action$meta$notifica = action.meta.notification,
          id = _action$meta$notifica.id,
          timeout = _action$meta$notifica.timeout,
          message = _action$meta$notifica.message,
          titleText = _action$meta$notifica.titleText,
          type = _action$meta$notifica.type,
          sticky = _action$meta$notifica.sticky,
          rest = (0, _objectWithoutProperties2.default)(_action$meta$notifica, ["id", "timeout", "message", "titleText", "type", "sticky"]);
      var notificationId = id || "ReduxMessenger-" + defaultId++;
      var notification = (0, _extends2.default)({}, rest, {
        id: notificationId,
        message: message,
        sticky: !!sticky,
        timeout: timeout != null ? timeout : _AlertConstants.FLOATING_ALERT_DEFAULT_TIMEOUT,
        timestamp: Date.now(),
        titleText: titleText,
        type: type
      });

      if (!sticky && type !== 'danger') {
        // clear any existing timeouts. If another alert is being
        // created for the same id, the timeout should be reset.
        clearTimeout(timeouts[notificationId]);
        timeouts[notificationId] = setTimeout(function () {
          dispatch((0, _NotificationActions.removeNotification)(notification.id));
        }, notification.timeout);
      }

      dispatch((0, _NotificationActions.postNotification)(notification));
      return result;
    };
  };
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ReduxMessenger/static-2.3840/js/middleware/NotificationMiddleware.js
// module id = 632
// module chunks = 209 210 211 212